import keys from 'lodash/keys';

import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

import { RANDOMIZATION_HYPOTHESIS_TESTING_FORM } from '../names';

import { getSelectedParameterType, getCategoricalSummary } from 'store/dataset';

const selector = formValueSelector(RANDOMIZATION_HYPOTHESIS_TESTING_FORM);

const makeFieldValueGetter = field =>
  state => selector(state, field);

export const getNullValue =
  makeFieldValueGetter('nullValue');

export const getPrimaryParameterName =
  makeFieldValueGetter('primaryParameter');

export const getSecondaryParameterName =
  makeFieldValueGetter('secondaryParameter');

export const getPrimaryParameterLevel =
  makeFieldValueGetter('primaryParameterLevel');

export const getTestSelection = makeFieldValueGetter('testSelection');
export const getNumberOfSamples = makeFieldValueGetter('numberOfSamples');

export const getAlpha = makeFieldValueGetter('alpha');
export const getTailType = makeFieldValueGetter('tailType');

export const getLeftCutoff = state => +selector(state, 'leftCutoff');
export const getRightCutoff = state => +selector(state, 'rightCutoff');

export const isPrimaryParameterLevelSelected =
  state => !!getPrimaryParameterLevel(state);

export const isPrimaryParameterSelected =
  state => !!getPrimaryParameterName(state);

export const isSecondaryParameterSelected =
  state => !!getSecondaryParameterName(state);

export const getPrimaryParameterType = state => {
  const parameterName = getPrimaryParameterName(state);
  return getSelectedParameterType(state, parameterName);
};

export const isPrimaryParameterNumerical = state =>
  getPrimaryParameterType(state) === 'numerical';

export const getPrimaryParameterLevels = createSelector(
  getPrimaryParameterName,
  getPrimaryParameterType,
  getCategoricalSummary,

  (primaryParameterName, primaryParameterType, summary) => {
    if (primaryParameterType === 'categorical') {
      return keys(summary[primaryParameterName].levels);
    }

    return null;
  }
);
